import { styled } from "@mui/material/styles";
import MuiToggleButton from "@mui/material/ToggleButton";
import { FS } from "@plannel/utils/font-util";

// 원형/알약 카테고리 토글 프리미티브 팩토리.
// 요일/주/월/일자 선택처럼 "색 + 지름"만 다른 다수의 중복 styled 정의를 대체한다.
//   swatch     : 색 스와치 객체. [700]=본색, [200]=미선택 테두리, [100]/[200]=hover, [900]=hover 글자.
//                @mui/material/colors 팔레트(red, blue, grey…) 또는 ColorUtil.roundToggleColor.
//   diameter   : 원 지름(px). 기본 35. pill 일 때는 높이 겸 모서리 반경.
//   shape      : "circle"(기본) | "pill".
//                circle 은 maxWidth 를 지름으로 묶어 정원을 보장한다 — 라벨 길이가 모두 같은
//                값 버튼(Jan, 1W, Sun)용. 라벨이 제각각인 버튼("Every", "First Day")에
//                circle 을 주면 borderRadius 50% 가 찌그러진 타원이 되므로 pill 을 쓴다.
//   hoverShade : hover 시 배경/테두리 명도(100 또는 200)
//   hoverText  : true면 hover 시 글자색을 swatch[900]로
//   borderShade: 미선택 테두리 명도. null(기본)이면 테두리가 글자색(swatch[700])을 따라간다.
//                200 을 주면 테두리만 연해져서 미선택 상태가 뒤로 물러난다.
export const createRoundToggleButton = (
  swatch,
  { diameter = 35, shape = "circle", hoverShade = 100, hoverText = false, borderShade = null } = {}
) =>
  styled(MuiToggleButton)(() => ({
    "&.MuiToggleButton-root": {
      // 테두리 색은 --rt-border 로 내보낸다. ToggleButtonGroup 이 그룹 내부 버튼의 테두리를
      // 더 높은 특정도로 다시 선언하기 때문에(border 단축 속성이 border-color 를 currentColor 로
      // 되돌린다) 여기서 borderColor 를 직접 잡아도 덮인다. 그룹 쪽에서 이 변수를 참조하면
      // 특정도와 무관하게 각 버튼이 자기 색을 유지한다.
      // borderShade 미지정 시 currentColor — 미선택은 글자색(swatch[700]), 선택 시엔 글자가
      // 흰색이 되므로 테두리도 흰 링이 된다. 이 팩토리의 원래 동작이라 그대로 둔다.
      "--rt-border": borderShade ? swatch[borderShade] : "currentColor",
      color: swatch[700],
      minWidth: diameter,
      minHeight: diameter,
      height: diameter,
      ...(shape === "pill"
        ? { borderRadius: diameter, padding: "0 14px" }
        : { maxWidth: diameter, borderRadius: "50%" }),
      textTransform: "unset",
      fontSize: FS.SUB,
      border: "1px solid",
      borderColor: "var(--rt-border)",
      "&.Mui-selected": {
        ...(borderShade ? { "--rt-border": swatch[700] } : {}),
        color: "white",
        background: swatch[700],
      },
      "&:hover": {
        "--rt-border": swatch[hoverShade],
        ...(hoverText ? { color: swatch[900] } : {}),
        borderColor: swatch[hoverShade],
        background: swatch[hoverShade],
      },
    },
  }));

export default createRoundToggleButton;
